//initialise and load config for the product from the API
import config from './config';
import {ApplicationEnvironmentConfig} from '../../custom-typings/typings';

const isValidApiKey = (key: string) : boolean => (key.indexOf('not-set') < 0) && `${key}`.length > 15

export const initialiseConfig = () => {
    fetch(config.apiUrl + '/config')
        .then(async configResponse => {
            const configReceived = (await configResponse.json()) as ApplicationEnvironmentConfig
            config.appConfig = {
                ...config.appConfig,
                ...configReceived,
                globalNavConfig: {
                    globalNavUrl: process.env.REACT_APP_GLOBAL_NAV_APIGEE_URL,
                    globalNavUrlApiKey: process.env.REACT_APP_GLOBAL_NAV_API_KEY,
                    globalNavLinksUrl: process.env.REACT_APP_GLOBAL_NAV_URL,
                    logoutUrl: process.env.REACT_APP_LOGOUT_URL ?? './logout',
                },
            };

            // now map this and populate other parts of the UI config. (for now, the config possibly needs a little restructure)
            if (isValidApiKey(configReceived.clientIdentifiers.address)) {
                config.apiKeys.address = configReceived.clientIdentifiers.address;
            }
// perform some config based on environment (in it1 turn on debug output)
            // enable debug output in it1 (TODO: the middle tier should configure this as a manifest/environment option)
            if (config.appConfig.environment === 'it1') {
                config.appConfig.enableDebug = true;
            }
            config.appConfig.loaded = true;

            console.log('globalNavUrl from config after initialised:' + config.appConfig.globalNavConfig.globalNavUrl);
            console.log('globalNavLinksUrl from config after initialised:' + config.appConfig.globalNavConfig.globalNavLinksUrl);
            console.log(
                'globalNavConfigs from config after initialised:' +
                config.appConfig.globalNavConfig.globalNavUrlApiKey?.substring(0, 6)
            );

            console.log('Application config has been initialised');
        }, err => {
            console.error('could not load config from the back end');
        });

    //Note: There is an existing issue with gaas template version as the config state setting before /config api response returns
    //and hence we always used to have global nav configs as not-specified. For this TRC component we are retrieving global nav api key
    //from the gitlab settings during build stage and setting as props.
    config.appConfig.globalNavConfig.globalNavUrl = process.env.REACT_APP_GLOBAL_NAV_APIGEE_URL;
    config.appConfig.globalNavConfig.globalNavUrlApiKey = process.env.REACT_APP_GLOBAL_NAV_API_KEY;
    config.appConfig.globalNavConfig.globalNavLinksUrl = process.env.REACT_APP_GLOBAL_NAV_URL;
    console.log('globalNavUrl from config after initialised:' + config.appConfig.globalNavConfig.globalNavUrl);
    console.log('globalNavLinksUrl from config after initialised:' + config.appConfig.globalNavConfig.globalNavLinksUrl);
    console.log('globalNavConfigs from config:' + config.appConfig.globalNavConfig.globalNavUrlApiKey?.substring(0, 6));
}
